/**
 * this closure handles the mechanics to
 * send the user's results to their email
 * once they've completed the steps in the
 * subject finder
 */
const _results = (function () {
    function Results({ dsIntegration, storage, helpers, origin, aiMethods }) {
        /**
         * emails the results link to the users
         * when they chose to have their results
         * received by email (at the results section)
         */
        const resultsInput = document.querySelector(
            `[data-role="subscription-card-input"]`
        );
        const resultsSubmit = document.querySelector(
            `[data-role="subscription-card-submit"]`
        );
        const resultsSubmitIcon = resultsSubmit.querySelector('svg');

        const resultsFirstName = document.querySelector(`
            [data-role="subscription-card-username"]
        `);
        const appError = document.querySelector(`[data-role="form-error"]`);

        let sendingEmail = false;

        resultsInput.addEventListener('keyup', ({ target }) => {
            if (!target.value) {
                resultsSubmit.disabled = true;

                target.classList.add('subject-finder__form-error');
                appError.textContent = '';

                return;
            }

            if (
                !target.value.match(/\w+@\w+\.\w+/) ||
                target.value.match(/ {1,}/)
            ) {
                resultsSubmit.disabled = true;

                target.classList.add('subject-finder__form-error');
                appError.textContent = 'Invalid email address entered.';

                return;
            }

            resultsSubmit.disabled = false;

            target.classList.remove('subject-finder__form-error');
            appError.textContent = '';
        });

        /**
         * set off email trigger in Matrix
         *
         * @param {string} userEmail
         * the user's email
         *
         * @param {callable} callback
         * the callback fires when the fetch requests
         * pass or if they fail
         *
         * @return {void}
         */
        async function emailResults(userEmail, callback) {
            resultsSubmitIcon.remove();

            helpers.loadSpinner(resultsSubmit);

            if (window.location.origin.match(/localhost/i)) {
                setTimeout(() => {
                    helpers.loadSpinner();

                    const stored = storage.get();

                    resultsSubmit.append(resultsSubmitIcon);

                    if (callback) callback();
                }, 1000);
                return;
            }

            const res = await fetch(
                `${window.location.origin}/_design/integration-points/subject-finder-subject-list/email-results-to-user?email=${userEmail}&userUid=${window.userUid}`
            ).catch((err) => {
                helpers.loadSpinner();

                resultsSubmit.append(resultsSubmitIcon);

                if (callback) callback();
                throw new Error(err);
            });

            const json = await res.json();

            if (!json.length) {
                // no one was found readout
                if (callback) callback();
                return;
            }

            // user found, hit Matrix to trigger and email
            /* eslint-disable camelcase */
            const { id, email, subject_finder_data } = json[0];

            await fetch(`${window.location.origin}/dev/email-results`, {
                method: 'POST',
                body: JSON.stringify({
                    userid: id,
                    email,
                    name: JSON.parse(decodeURIComponent(subject_finder_data))
                        .about.questions['about-details']['users-name'],
                }),
            })
                .then((resp) => {
                    helpers.loadSpinner();

                    resultsSubmit.append(resultsSubmitIcon);
                    aiMethods.sendSubscription();

                    if (callback) callback();
                })
                .catch((err) => {
                    helpers.loadSpinner();

                    console.log(`Error sending email: ${err}`);

                    resultsSubmit.append(resultsSubmitIcon);

                    if (callback) callback();

                    throw new Error(err);
                });
        }

        /**
         * gets called when the submit button is clicked
         * or the email input is submitted
         *
         * this will trigger the emailResults() function
         */
        function submitEmail(data, input) {
            const currentData = data;
            const emailInput = input;
            const emailValue = emailInput.value;
            const resultsEmailErrorMessage = document.querySelector(
                `[data-role="email-results-error"]`
            );

            console.log('Starting email submission.');

            if (emailValue && !resultsFirstName.value) {
                const errorOutput = document.createElement('span');

                errorOutput.classList.add('subject-finder__form-error-text');
                errorOutput.dataset.role = 'email-results-error';

                resultsFirstName.classList.add('subject-finder__form-error');
                errorOutput.textContent = 'Please add your first name.';

                resultsSubmit.after(errorOutput);

                return;
            }

            if (resultsEmailErrorMessage) {
                resultsEmailErrorMessage.remove();
                resultsFirstName.classList.remove('subject-finder__form-error');
            }

            resultsSubmit.disabled = true;

            if (!window.userUid || !currentData.userUid) {
                if (sendingEmail) return;

                sendingEmail = true;
                console.log('No user session found - checking store.');

                if (
                    !currentData.about.questions['about-details'] ||
                    !currentData.about.questions['about-details']['users-email']
                ) {
                    if (!currentData.about.questions['about-details']) {
                        currentData.about.questions['about-details'] = {};
                    }

                    currentData.about.questions['about-details'][
                        'users-email'
                    ] = resultsInput.value;

                    currentData.about.questions['about-details']['users-name'] =
                        resultsFirstName.value;

                    emailInput.value = resultsInput.value;

                    storage.set(currentData);
                }

                // first check if a user with the specified email exists
                dsIntegration.userEmailExists(emailValue, (user) => {
                    // user found update local storage and send email
                    if (user.length) {
                        console.log('User found from store.');
                        window.userUid = user[0].id;
                        currentData.userUid = user[0].id;

                        // Update user again to store results
                        dsIntegration.updateUserData.bind(this)(
                            {
                                results_keywords: encodeURIComponent(
                                    JSON.stringify(currentData.results_keywords)
                                ),
                            },
                            () => {
                                emailResults(resultsInput.value, () => {
                                    resultsSubmit.disabled = false;
                                    sendingEmail = false;

                                    storage.set(currentData);
                                });
                            }
                        );
                    }
                });
            } else {
                console.log('Updating user, sending email.');
                dsIntegration.updateUserData.bind(this)(
                    {
                        results_keywords: encodeURIComponent(
                            JSON.stringify(currentData.results_keywords)
                        ),
                    },
                    () => {
                        emailResults(resultsInput.value, () => {
                            resultsSubmit.disabled = false;
                            sendingEmail = false;

                            console.log('User found from store.');
                            storage.set(currentData);
                        });
                    }
                );
            }
        }

        /// ////////////////////////////////////////
        // -- event listeners

        resultsInput.addEventListener('keyup', (e) => {
            if (e.key && e.key.match(/enter/i) && e.target.value) {
                const currentData = storage.get();
                const emailInput = document.querySelector(
                    `[data-role="subscription-card-input"]`
                );

                resultsInput.disabled = true;
                submitEmail(currentData, emailInput);
            }
        });

        resultsSubmit.addEventListener('click', () => {
            if (resultsInput.value) {
                console.log('Email entered.');
                const currentData = storage.get();
                const emailInput = document.querySelector(
                    `[data-role="subscription-card-input"]`
                );

                resultsInput.disabled = true;
                submitEmail(currentData, emailInput);
            }
        });
    }

    return (props) => {
        return new Results(props);
    };
})();

export default _results;
